<template>
  <BaseBulkSendFeatureUnavailableEmptyState>
    <i18n
      path="ui.bulkSend.emptyState.featureUnavailable.info"
      tag="p">
      <template v-slot:link>
        <RouterLink
          :to="{ name: 'Billing' }"
          data-ec="bulk_send_dashboard"
          data-et="empty_state_upsell_link"
        >
          {{ $t('ui.bulkSend.emptyState.featureUnavailable.ctaSuperAdmin') }}
        </RouterLink>
      </template>
    </i18n>
  </BaseBulkSendFeatureUnavailableEmptyState>
</template>

<script>
import BaseBulkSendFeatureUnavailableEmptyState
  from '@/components/ui/bulkSend/BaseBulkSendFeatureUnavailableEmptyState.vue';

export default {
  name: 'BulkSendFeatureUnavailableEmptyStateSuperAdmin',
  components: {
    BaseBulkSendFeatureUnavailableEmptyState,
  },
};
</script>
